'use strict';

angular.module('cgmemApp')
	.controller('AuthWrapCtrl', function ($location, $rootScope, $scope, $state, $stateParams, $log, ngToast, WorkingAccount, User, AppConfig) {
		$scope.isCollapsed = true;
		$scope.authAlert = 'placeholder';

		$scope.isActive = function (route) {
			return route === $location.path().substr(0, route.length);
		};

		$scope.intersection = function (a, b) {
			return _.intersection(a, b)
		}

		AppConfig.get()
			.then(function (appConfig) {
				$scope.appConfig = appConfig;
			})
			.catch(function (err) {
					$log.warn("WrapCtrl: AppConfig.get() rejected with:", err);
					$scope.loadFailure = true;
			});

		User.get()
			.then(function (user) {
				//$log.info("User:",user);
				$scope.user = user;
				$scope.foreignAccount = function () {
					var u = User.getSync();
					var a = WorkingAccount.getSync();
					return ((u && a && a.account && u.accountId != a.account._id) ? a.account.accountNumber : false);
				}

				$scope.resetAccountSelection = function () {
					//$log.log("Resetting to default account");
					WorkingAccount.get('0')
						.then(function (a) {
							//$log.log("Account reset to",a.account.accountNumber);
						}, function (err) {
							$log.error("WorkingAccountReload failed up:", err);
						});
				}

			},
				function (err) {
					if (err.status == 401) {
						$log.warn("WrapCtrl - got 401.  State change should follow on rootscope event")
						//$state.go('login');
					}
					else {
						$log.warn("WrapCtrl: User.get() rejected with:", err);
						$scope.loadFailure = true;
					}
				});

		$scope.logout = User.logout;

		// collapse menu when state change
		var stateChangeListener = $rootScope.$on('$stateChangeStart',
			function (event, toState, toParams, fromState, fromParams) {
				//$log.info("Changing states from '"+fromState.name+"' to '"+toState.name+"'");
				$scope.isCollapsed = true;
			});

		var myAlertListener = $rootScope.$on('generalAlert', function (event, data) {
			$log.warn('Got generalAlert:' + data);
			ngToast.create({
				content: data,
				dismissOnTimeout: true,
				timeout: 20000,
				dismissButton: true,
				className: 'danger'
			  });
		});

		var notAuthListener = $rootScope.$on('401', function (event, data) {
			$log.warn('WrapCtrl: Got 401, Redirecting to login');
			if($scope.foreignAccount && $scope.foreignAccount()) {
				$log.warn('Going to login state with no parameters')
				$state.go('login');
			} else {
				//$state.go('login');
				$state.go('login', {redirect: $state.current.name, stateParams: $stateParams});
			}
		});

		$scope.$on('$destroy', () => {
			stateChangeListener();
			myAlertListener();
			notAuthListener();
			ngToast.dismiss();
		});
	});

